import { render } from "./pegawai-detail.vue?vue&type=template&id=16726e3f"
import script from "./pegawai-detail.vue?vue&type=script&lang=js"
export * from "./pegawai-detail.vue?vue&type=script&lang=js"

import "./pegawai-detail.vue?vue&type=style&index=0&id=16726e3f&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__